<template>
    <div style="background-color: #fff;height: 100%;">
        <div style="padding: 20px;">
      <div>
        <el-row v-show="!disabled">
          <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
        </el-row>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>
          <el-table
            :data="tableData"
            :height="th"
            border
            style="width: 100%;"
          >
            <el-table-column prop="elderlyName" width="150" label="姓名"></el-table-column>
            <el-table-column prop="inspectItem" width="150" label="体检项目"></el-table-column>
            <el-table-column prop="organizationName" width="150" label="体检机构"></el-table-column>
            <el-table-column prop="inspectTime" label="体检时间" ></el-table-column>
            <el-table-column prop="details" label="详情" ></el-table-column>
          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div
              style="float: left;padding: 5px;"
            >共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page.sync="currentPage"  @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>
    <ExaminationRecordsAdd ref="myExaminationRecordsAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:resultSuccess="resultSuccess"></ExaminationRecordsAdd>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import ExaminationRecordsAdd from "./ExaminationRecordsAdd";

    export default {
        name: "ExaminationRecords",
        data(){
            return{
                showModalAdd: false,
                disabled: false,
                tableData: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                th: 0,
                elderlyCode: "",
                elderlyName:"",
            }
        },
        created(){
            this.th = this.$store.state.tableHeight-90;
        },
        components:{
            ExaminationRecordsAdd
        },
        watch: {
            //监听全局变量
            "$store.state.tableHeight": function (val) {
              this.th = val-90;
            },
            disabled(val){
              this.th = this.$store.state.tableHeight-(val?50:100);
            }
        },
        methods:{
            init(flag,row,disabled) {
                if(disabled)this.disabled=disabled
                this.elderlyCode = row.elderlyCode;
                this.elderlyName = row.name;
                if(flag){
                  this.getList();
                }
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myExaminationRecordsAdd.init(this.elderlyCode,this.elderlyName);
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            resultSuccess(){
              this.currentPage = 1;
              this.getList();
            },
            getList() {
            this.$axios({
                method: "post",
                url: this.$shopUrl + "EInspectRecord/Page",
                data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                staffCode: getStaffCode(),
                elderlyCode: this.elderlyCode,
                pageIndex: this.currentPage,
                pageSize: this.pageSize,
                },
            })
                .then((response) => {
                console.log(response);
                if (response.data.error == 0) {
                    this.tableData = response.data.data.list;
                    this.totalItems = response.data.data.total;
                } else if (response.data.error == 1) {
                    this.$message.error(response.data.message);
                }
                })
                .catch(function (error) {
                console.log(error);
                });
            },
        },
    }
</script>

<style scoped>

</style>
